export default __webpack_public_path__ + "static/media/done-teal.b10c8f2a.svg";